import { invoke } from '@shared/easyfy.decorators';
import SliderHelper from '@clientShared/sliderHelper';
@invoke
export default class BannerComponent {
  static Instance: BannerComponent;
  private static readonly PER_PAGE = 1;

  onInit() {
    BannerComponent.refreshBannerComponent();
    BannerComponent.hideEmptyBannerItems();
  }

  private static hideEmptyBannerItems = (): void => {
    const bannerItems = document.querySelectorAll('.banner-item');

    bannerItems.forEach((item) => {
      if (!(item instanceof HTMLElement)) return;
      const emptyImage = item.querySelector('img.empty');

      if (emptyImage) {
        item.classList.add('is-empty');
      }
    });
  };

  static refreshBannerComponent = (): void => {
    const selector = '[data-container="banner-full-slider"]';
    document.querySelectorAll(selector).forEach((list) => {
      if (!(list instanceof HTMLElement) || list.classList.contains('splide')) return;

      BannerComponent.removeEmptySlidesFromDOM(list);

      const numberOfSlides = BannerComponent.getNumberOfSlides(list);
      if (numberOfSlides === 0) {
        list.remove();
        return;
      }

      if (numberOfSlides === BannerComponent.PER_PAGE) {
        SliderHelper.RemoveSliderControls(list);
        return;
      }

      BannerComponent.initializeSlider(list);
    });
  };

  // We have to generate 3 empty slides before calling Kevel in the cf worker
  // Therefore we need to remove placeholder slides if no ads are returned from Kevel
  private static removeEmptySlidesFromDOM = (list: HTMLElement): void => {
    const slidesArray = Array.from(list.querySelectorAll('.splide__slide'));
    for (const slide of slidesArray) {
      const img = slide.querySelector('img');
      if (!img || img.classList?.contains('empty')) {
        slide.remove();
      }
    }
  };

  private static getNumberOfSlides = (list: HTMLElement): number => {
    return list.querySelectorAll('.splide__slide').length;
  };

  private static initializeSlider(list: HTMLElement): void {
    list.classList.add('splide');

    // A11y, disable autoplay if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const slider = SliderHelper.CreateSlider(list, {
      type: 'loop',
      perPage: BannerComponent.PER_PAGE,
      autoplay: !prefersReducedMotion,
      interval: 7000,
      arrows: true, // Removed in the mobile view with CSS
      snap: true,
      pagination: true,
      mediaQuery: 'min',
      // Splide otherwise moves is-active only once the transition ends, and at 0 speed under
      // prefers-reduced-motion it ends immediately. The arrows read the active slide when the
      // click arrives, so without this they report the slide left for some users and the slide
      // navigated to for others.
      updateOnMove: true,
    });

    // Both arrows and pagination declare their tracking in the markup; the bullets only need it
    // carried over from the list Splide builds them into.
    SliderHelper.TrackPaginationNavigation(slider);
    SliderHelper.MountSlider(slider);
  }
}
